import User from './user';
import Towns from './towns';
import Cities from './cities';
import Basket from './basket';
import Orders from './orders';
import Regions from './regions';
import Settings from './settings';
import MenuItems from './menu_items';
import Restaurants from './restaurants';
import PaymentModes from './payment_modes';

export default {
	User,
	Towns,
	Cities,
	Basket,	
	Orders,
	Regions,
	Settings,
	MenuItems,
	Restaurants,
	PaymentModes
}


// WEBPACK FOOTER //
// ./src/store/modules/index.js